import { createElementVNode as _createElementVNode, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/social-media/facebook.svg'
import _imports_1 from '../assets/img/social-media/instagram.svg'
import _imports_2 from '../assets/img/social-media/youtube.svg'


const _withScopeId = n => (_pushScopeId("data-v-3c98219c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "social-media-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.facebook.com/GobiernoMunicipalDeSanmarcos2021.2024/",
  target: "_blank",
  key: 1
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "icon",
    src: _imports_0,
    alt: "facebook"
  })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.facebook.com/GobiernoMunicipalDeSanmarcos2021.2024/",
  target: "_blank",
  key: 2
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "icon",
    src: _imports_1,
    alt: "instagram"
  })
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.facebook.com/GobiernoMunicipalDeSanmarcos2021.2024/",
  target: "_blank",
  key: 3
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "icon",
    src: _imports_2,
    alt: "youtube"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_TransitionGroup, {
      name: "icon",
      appear: ""
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _hoisted_3,
        _hoisted_4
      ]),
      _: 1
    })
  ]))
}